import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  TextField,
  Button,
  CircularProgress,
  Paper,
  Alert,
} from "@mui/material";
import API_BASE_NUCLEOREAD from "../../config_NucleoRead";

function NucleoRead() {
  const [fasta, setFasta] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  /* ================= SAFE POLLER ================= */
  const pollResult = async (jobId) => {
    const MAX_ATTEMPTS = 25;
    let attempt = 0;

    console.log("🧬 [NucleoRead] Starting polling for:", jobId);

    while (attempt < MAX_ATTEMPTS) {
      attempt++;

      const url = `${API_BASE_NUCLEOREAD}/api/result?job_id=${jobId}&t=${Date.now()}`;
      console.log("🔁 Polling:", url);

      const res = await fetch(url);
      const data = await res.json();

      console.log(`📡 Poll #${attempt} response:`, data);

      if (data.status === "ready") {
        console.log("✅ Result ready:", data);
        return data;
      }

      await new Promise((r) => setTimeout(r, 4000));
    }

    throw new Error("Timed out waiting for NucleoRead job");
  };

  /* ================= ANALYZE ================= */
  const handleAnalyzeClick = async (e) => {
    e.preventDefault();
    setError(null);

    if (!fasta.trim().startsWith(">")) {
      setError("Invalid FASTA. Must start with >");
      return;
    }

    try {
      setLoading(true);

      console.log("📤 Submitting FASTA to NucleoRead...");

      const res = await fetch(`${API_BASE_NUCLEOREAD}/api/analyze`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fasta }),
      });

      const submitData = await res.json();
      console.log("🚀 Submit response:", submitData);

      if (!res.ok) {
        throw new Error(submitData.error || "Failed to submit job");
      }

      const { job_id } = submitData;

      console.log("🧪 Job ID:", job_id);

      const finalData = await pollResult(job_id);

      setLoading(false);

      console.log("🎉 Final NucleoRead data:", finalData);

      navigate("/seqintel/nucleoread/results", {
        state: {
          fasta,
          job_id,
          result: finalData.result,
          images: finalData.images,
        },
      });
    } catch (err) {
      console.error("❌ NucleoRead error:", err);
      setLoading(false);
      setError(err.message);
    }
  };

  return (
    <Paper sx={{ maxWidth: 600, mx: "auto", p: 4 }}>
      <Typography variant="h5" fontWeight={700} textAlign="center">
        🧬 NucleoRead
      </Typography>

      <Typography variant="body2" textAlign="center" sx={{ mb: 2 }}>
        Cloud Genomic Analysis Engine
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}

      <form onSubmit={handleAnalyzeClick}>
        <TextField
          fullWidth
          label="FASTA Sequence"
          value={fasta}
          onChange={(e) => setFasta(e.target.value)}
          multiline
          minRows={6}
          sx={{ mb: 3 }}
          placeholder=">gene1\nATGCGT..."
        />

        <Button type="submit" fullWidth variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Run Analysis"}
        </Button>
      </form>
    </Paper>
  );
}

export default NucleoRead;
